module.exports = __webpack_public_path__ + "static/media/custom.c33bd3ab.png";